export default __webpack_public_path__ + "static/media/009c49546eae9b4935c49cda07627f1b.jpg";